/**
 * Recursively find a value by key in a nested object or array
 * @param {Object|Array} obj - The object or array to search
 * @param {string} key - The key to find
 * @returns {*} - The value if found, undefined otherwise
 */
export function findKeyValue(obj, key) {
  if (!obj || typeof obj !== 'object') return undefined;

  // If the current level is an array, iterate through its elements
  if (Array.isArray(obj)) {
    for (const item of obj) {
      const value = findKeyValue(item, key);
      if (value !== undefined) {
        return value;
      }
    }
  } else {
    // If the current level is an object, check for the key and iterate through its properties
    if (obj.hasOwnProperty(key)) {
      return obj[key];
    }

    for (const k in obj) {
      if (obj.hasOwnProperty(k)) {
        const value = findKeyValue(obj[k], key);
        if (value !== undefined) {
          return value;
        }
      }
    }
  }

  return undefined;
}

